import { IGif } from "../services/types";
import { apiMain } from "../services";

export const getGifIds = async (gifs: IGif[]) => {
  const ids: string[] = [];
  const requests = [];

  for (const gif of gifs) {
    if (!gif.gallery) {
      ids.push(gif.id);
      continue;
    }

    requests.push(apiMain.getGallery(gif.gallery));
  }

  if (requests.length > 0) {
    const results = await Promise.all(requests);
    results.forEach(({ gifs }) => {
      gifs.forEach(({ id }) => {
        ids.push(id);
      });
    });
  }

  return ids;
};
